import styles from './news_item.module.scss';
import {classNames} from '../../../support/classnames.ts';
import {AltButton} from '../../../components/button/alt_button.tsx';
import {NewsItemType} from '../../../gql/pwa/graphql.ts';
import {formatDate} from '../../../support/days_from_now.ts';
import {Link} from 'react-router-dom';

interface OwnProps {
    highlighted?: boolean;
    newsItem?: NewsItemType | null;
}

export function NewsItem({highlighted, newsItem}: OwnProps) {
    return (
        <Link
            to={`/news/${newsItem?.id}`}
            className={classNames(styles.news_item, {
                [styles.highlighted]: highlighted,
            })}
        >
            <div className={styles.news_item__image}>
                <img
                    src={newsItem?.thumbnail ?? ''}
                    alt={'image'}
                    onError={(e) => (e.currentTarget.style.display = 'none')}
                />
            </div>

            <div className={styles.news_item__content}>
                <div className={styles.content__title}>
                    <h2>{newsItem?.title}</h2>
                    <span className={styles.title__date}>
                        {newsItem?.publish_date ? formatDate(newsItem?.publish_date) : null}
                    </span>
                </div>

                <div className={styles.content__content}>
                    {newsItem?.small_description}
                    <AltButton>
                        <i className={'fa-light fa-arrow-right'} />
                    </AltButton>
                </div>
            </div>
        </Link>
    );
}
